var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 42.5179,
    height: 42.5179,
    rx: 11.5,
    fill: "#FCF7D7",
    stroke: "#FAF1B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3099 12C21.7518 12.0001 22.1761 12.1758 22.4886 12.4883L27.3451 17.3447C27.6575 17.6572 27.8333 18.0816 27.8333 18.5234V21.7188C27.4308 21.6309 27.0123 21.583 26.5833 21.583C23.3618 21.5832 20.7503 24.1954 20.7503 27.417C20.7504 29.2769 21.6221 30.9319 22.9779 32H14.5003C13.5799 32 12.8333 31.2535 12.8333 30.333V13.667C12.8333 12.7465 13.5799 12 14.5003 12H21.3099ZM26.5833 22.833C29.1145 22.8332 31.1673 24.8858 31.1673 27.417C31.1671 29.948 29.1144 31.9998 26.5833 32C24.0523 31.9998 22.0005 29.948 22.0003 27.417C22.0003 24.8858 24.0522 22.8332 26.5833 22.833ZM26.5833 24.5C26.2382 24.5 25.9583 24.7798 25.9583 25.125V26.792H24.2913C23.9463 26.7922 23.6663 27.0719 23.6663 27.417C23.6665 27.7619 23.9464 28.0418 24.2913 28.042H25.9583V29.708C25.9583 30.0532 26.2382 30.333 26.5833 30.333C26.9285 30.333 27.2083 30.0532 27.2083 29.708V28.042H28.8753C29.2202 28.0418 29.5002 27.7619 29.5003 27.417C29.5003 27.0719 29.2204 26.7922 28.8753 26.792H27.2083V25.125C27.2083 24.7798 26.9285 24.5 26.5833 24.5Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.3183ad63871cbfd9c5804525557539b2.svg";
export { ForwardRef as ReactComponent };